const ch = {
    common: {
        history: "ankstesnės versijos"
    }
};
export default ch;



// WEBPACK FOOTER //
// ./src/i18n/langs/lt.js